/**
 * Deviation Slice
 *
 * State and actions for deviation view filters.
 */

import type { StateCreator } from 'zustand';
import type { AppStore, DeviationSlice } from '../types';

export const createDeviationSlice: StateCreator<AppStore, [], [], DeviationSlice> = (set) => ({
  deviationGroupBy: null,
  deviationFilter: 'all',
  deviationAssignee: null,

  setDeviationGroupBy: (groupBy) => set({ deviationGroupBy: groupBy }),
  setDeviationFilter: (filter) => set({ deviationFilter: filter }),
  setDeviationAssignee: (assignee) => set({ deviationAssignee: assignee }),
});
